<div class="standardize-execute-wrapper" *ngIf="!showStandardizeProcess">
  <span class="title-header">
    {{ 'labor_contract_standardize.execute.title_header' | translate }}
  </span>
  <!-- ============= KHỐI TÌM KIẾM ============= -->
  <mat-accordion #accordion="matAccordion" [multi]="true">
    <mat-expansion-panel expanded="true" class="mt-3">
      <mat-expansion-panel-header>
        <mat-panel-title class="mat-panel-title">
          {{ 'labor_contract_standardize.execute.search_title' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <form #executeSearchForm="ngForm" (ngSubmit)="onSearch()" class="pb-3">
        <div class="row">

          <!-- Tên / Mã hợp đồng văn bản -->
          <div class="col-lg-4 col-md-4">
            <mat-form-field class="w-100">
              <input type="text"
                     matInput
                     name="nameOrCode"
                     [(ngModel)]="documents.nameOrCode"
                     [placeholder]="'labor_contract_standardize.execute.contract_code_name_placeholder' | translate"
                     maxlength="255"
                     autocomplete="off"
                     (focusout)="documents.nameOrCode = documents.nameOrCode == undefined ? '' : (documents.nameOrCode + '').trim()">
              <button mat-button *ngIf="documents.nameOrCode" type="button" matSuffix mat-icon-button
                      aria-label="Clear" (click)="documents.nameOrCode=''">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <!-- Loại hợp đồng văn bản -->
          <div class="col-lg-4 col-md-4">
            <mat-form-field class="w-100">
              <mat-label>{{ 'labor_contract_standardize.execute.contract_type' | translate }}</mat-label>
              <mat-select #serviceTypeSelect
                          name="serviceType"
                          id="serviceType"
                          [(ngModel)]="documents.serviceType"
                          (focusout)="checkFocus = true"
                          (ngModelChange)="onSearch()"
                          (selectionChange)="checkFocus = false"
                          (focus)="commonService.openComboBox(checkFocus, serviceTypeSelect)">
                <mat-option>
                  <ngx-mat-select-search
                    [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                    [placeholderLabel]="'search_form.search' | translate"
                    [formControl]="serviceTypesFilterCtrl">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option [value]="null"
                            (click)="commonService.closeDropdownList(serviceTypeSelect)">
                  {{ 'form.select_all' | translate }}
                </mat-option>
                <mat-option *ngFor="let serviceType of filteredServiceTypes | async"
                            [value]="serviceType.id"
                            (click)="commonService.closeDropdownList(serviceTypeSelect)">
                  {{ serviceType.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Trạng thái chuẩn hóa -->
          <div class="col-lg-4 col-md-4">
            <mat-form-field class="w-100">
              <mat-label>{{ 'labor_contract_standardize.execute.status_standardize' | translate }}</mat-label>
              <mat-select #statusStandardizedSelect
                          (focusout)="(checkFocus = true)"
                          (selectionChange)="checkFocus = false"
                          (focus)="commonService.openComboBox(checkFocus, statusStandardizedSelect)"
                          id="statusStandardized"
                          name="statusStandardized"
                          [(ngModel)]="documents.statusStandardized"
                          (ngModelChange)="onSearch()"
                          [disabled]="!executeSearchForm.valid">
                <mat-option [value]="null" selected
                            (click)="commonService.closeDropdownList(statusStandardizedSelect)">
                  {{ 'common.all' | translate }}
                </mat-option>
                <mat-option *ngFor="let item of standardizeStatusOptions"
                            [value]="item.value"
                            (click)="commonService.closeDropdownList(statusStandardizedSelect)">
                  {{ item.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <ng-container *ngIf="showAdvancedSearch">

            <!-- Trạng thái hợp lệ của CKS NLĐ -->
            <div class="col-lg-4 col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{ 'labor_contract_standardize.execute.status_cks_nld' | translate }}</mat-label>
                <mat-select #statusDigitalCertPersonalSelect
                            (focusout)="(checkFocus = true)"
                            (selectionChange)="checkFocus = false"
                            (focus)="commonService.openComboBox(checkFocus, statusDigitalCertPersonalSelect)"
                            id="statusDigitalCertPersonal"
                            name="statusDigitalCertPersonal"
                            [(ngModel)]="documents.statusDigitalCertPersonal"
                            (ngModelChange)="onSearch()"
                            [disabled]="!executeSearchForm.valid">
                  <mat-option [value]="null" selected
                              (click)="commonService.closeDropdownList(statusDigitalCertPersonalSelect)">
                    {{ 'common.all' | translate }}
                  </mat-option>
                  <mat-option *ngFor="let item of cksStatusOptions"
                              [value]="item.value"
                              (click)="commonService.closeDropdownList(statusDigitalCertPersonalSelect)">
                    {{ item.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Trạng thái bổ sung thông tin BC HĐLĐ -->
            <div class="col-lg-4 col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{ 'labor_contract_standardize.execute.status_supplement_hdld' | translate }}</mat-label>
                <mat-select #updateInfoPropertiesSelect
                            (focusout)="(checkFocus = true)"
                            (selectionChange)="checkFocus = false"
                            (focus)="commonService.openComboBox(checkFocus, updateInfoPropertiesSelect)"
                            id="updateInfoProperties"
                            name="updateInfoProperties"
                            [(ngModel)]="documents.updateInfoProperties"
                            (ngModelChange)="onSearch()"
                            [disabled]="!executeSearchForm.valid">
                  <mat-option [value]="null" selected
                              (click)="commonService.closeDropdownList(updateInfoPropertiesSelect)">
                    {{ 'common.all' | translate }}
                  </mat-option>
                  <mat-option *ngFor="let item of supplementStatusOptions"
                              [value]="item.value"
                              (click)="commonService.closeDropdownList(updateInfoPropertiesSelect)">
                    {{ item.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Trạng thái hợp lệ của CKS NSDLĐ -->
            <div class="col-lg-4 col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{ 'labor_contract_standardize.execute.status_cks_nsdld' | translate }}</mat-label>
                <mat-select #statusDigitalCertSelect
                            (focusout)="(checkFocus = true)"
                            (selectionChange)="checkFocus = false"
                            (focus)="commonService.openComboBox(checkFocus, statusDigitalCertSelect)"
                            id="statusDigitalCert"
                            name="statusDigitalCert"
                            [(ngModel)]="documents.statusDigitalCert"
                            (ngModelChange)="onSearch()"
                            [disabled]="!executeSearchForm.valid">
                  <mat-option [value]="null" selected
                              (click)="commonService.closeDropdownList(statusDigitalCertSelect)">
                    {{ 'common.all' | translate }}
                  </mat-option>
                  <mat-option *ngFor="let item of cksStatusOptions"
                              [value]="item.value"
                              (click)="commonService.closeDropdownList(statusDigitalCertSelect)">
                    {{ item.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </ng-container>
        </div>

        <!-- Thu gọn/mở rộng tìm kiếm -->
        <div class="row">
          <div class="col-lg-12 col-md-6 d-flex justify-content-end">
            <button *ngIf="showAdvancedSearch" type="button" mat-button class="advance-search"
                    (click)="toggleAdvancedSearch()">
              <span>{{ 'enterprise_contract.buttons.basic' | translate }}</span>
              <em class="material-icons">keyboard_arrow_up</em>
            </button>
            <button *ngIf="!showAdvancedSearch" type="button" mat-button class="advance-search"
                    (click)="toggleAdvancedSearch()">
              <span>{{ 'enterprise_contract.buttons.advance' | translate }}</span>
              <em class="material-icons">keyboard_arrow_down</em>
            </button>
          </div>
        </div>

        <!-- Nút tìm kiếm -->
        <div class="row mt-3">
          <div class="col-lg-12 d-flex justify-content-center">
            <button mat-stroked-button color="primary" type="submit"
                    [disabled]="!executeSearchForm.valid">
              <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
              {{ 'labor_contract_standardize.execute.btn_search' | translate }}
            </button>
          </div>
        </div>
      </form>
    </mat-expansion-panel>
  </mat-accordion>

  <!-- ============= KHỐI DANH SÁCH ============= -->
  <mat-accordion #accordion="matAccordion" [multi]="true">
    <mat-expansion-panel expanded="true" class="mt-3">
      <mat-panel-title class="mat-panel-title mb-0 pb-3 mt-3 d-flex align-items-center list-title-mine ">
        <div class="d-flex justify-content-between align-items-center mt-3 mb-2 list-header">
          <div class="list-title">
            {{ 'labor_contract_standardize.execute.list_title' | translate }} ({{ paginate.totalRow }}),
            {{ 'labor_contract_standardize.execute.selected_count' | translate }}: {{ selection.selected.length }}
          </div>
      
          <div class="d-flex buttonMD align-items-center">
            <button class="mr-1 btn1-mine"
                    mat-stroked-button
                    color="primary"
                    type="button"
                    (click)="onStandardizeSelected()">
              <!-- <mat-icon class="mr-0">play_circle_outline</mat-icon> -->
              {{ 'labor_contract_standardize.execute.btn_standardize' | translate }}
            </button>
      
            <button class="btn1-mine"
                    mat-stroked-button
                    color="primary"
                    type="button"
                    [disabled]="!dataSource.data || dataSource.data.length === 0"
                    (click)="onStandardizeAll()">
              <!-- <mat-icon class="mr-0">play_circle_outline</mat-icon> -->
              {{ 'labor_contract_standardize.execute.btn_standardize_all' | translate }}
            </button>
          </div>
        </div>
      </mat-panel-title>

      <div class="table-responsive">
        <mat-table [dataSource]="dataSource.data"
                   class="w-100 mat-table-col-extra-sm standardize-execute-table">
    
          <!-- Checkbox -->
          <ng-container matColumnDef="check-col">
            <mat-header-cell *matHeaderCellDef
                             class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom">
              <mat-checkbox *ngIf="dataSource && dataSource.data && dataSource.data.length"
                            (change)="$event ? masterToggle() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            color="primary">
              </mat-checkbox>
            </mat-header-cell>
            <mat-cell *matCellDef="let element"
                      class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom"
                      (click)="$event.stopPropagation()">
              <mat-checkbox color="primary"
                            (click)="$event.stopPropagation()"
                            (change)="$event ? addListRecord(element) : null"
                            [checked]="selection.isSelected(element.id)">
              </mat-checkbox>
            </mat-cell>
          </ng-container>
    
          <!-- STT -->
          <ng-container matColumnDef="stt">
            <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
              {{ 'labor_contract_standardize.execute.table_headers.no' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
              <span class="fix-width text-center">{{ element.stt }}</span>
            </mat-cell>
          </ng-container>
    
          <!-- Mã - Tên hợp đồng -->
          <ng-container matColumnDef="codeName">
            <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
              {{ 'labor_contract_standardize.execute.table_headers.contract_code_name' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" [matTooltip]="element.codeName" class="mat-cell-non-boder-right-bottom">
              <span class="fix-width">{{ element.codeName }}</span>
            </mat-cell>
          </ng-container>
    
          <!-- Loại hợp đồng -->
          <ng-container matColumnDef="contractType">
            <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
              {{ 'labor_contract_standardize.execute.table_headers.contract_type' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" [matTooltip]="element.contractType" class="mat-cell-non-boder-right-bottom">
              <span class="fix-width">{{ element.contractType }}</span>
            </mat-cell>
          </ng-container>
    
          <!-- Các bên ký kết -->
          <ng-container matColumnDef="parties">
            <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
              {{ 'labor_contract_standardize.execute.table_headers.parties' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" [matTooltip]="element.parties" class="mat-cell-non-boder-right-bottom">
              <span class="fix-width">{{ element.parties }}</span>
            </mat-cell>
          </ng-container>
    
          <!-- Trạng thái CKS NSDLĐ -->
          <ng-container matColumnDef="statusCksNsdld">
            <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
              {{ 'labor_contract_standardize.execute.table_headers.status_cks_nsdld' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom">
              <nz-tag *ngIf="element.statusCksNsdld" [nzColor]="getStatusTagColor(element.statusCksNsdld)" style="margin-right: 0px;">
                {{ getStatusLabel(element.statusCksNsdld) }}
              </nz-tag>
            </mat-cell>
          </ng-container>
    
          <!-- Trạng thái CKS NLĐ -->
          <ng-container matColumnDef="statusCksNld">
            <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
              {{ 'labor_contract_standardize.execute.table_headers.status_cks_nld' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom">
              <nz-tag *ngIf="element.statusCksNld" [nzColor]="getStatusTagColor(element.statusCksNld)" style="margin-right: 0px;">
                {{ getStatusLabel(element.statusCksNld) }}
              </nz-tag>
            </mat-cell>
          </ng-container>
    
          <!-- Trạng thái bổ sung dữ liệu HĐLĐ -->
          <ng-container matColumnDef="statusSupplementHDLD">
            <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
              {{ 'labor_contract_standardize.execute.table_headers.status_supplement_hdld' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom">
              <nz-tag *ngIf="element.statusSupplementHDLD" [nzColor]="getStatusTagColor(element.statusSupplementHDLD)" style="margin-right: 0px;">
                {{ getStatusLabel(element.statusSupplementHDLD) }}
              </nz-tag>
            </mat-cell>
          </ng-container>
    
          <!-- Trạng thái chuẩn hóa -->
          <ng-container matColumnDef="statusStandardized">
            <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
              {{ 'labor_contract_standardize.execute.table_headers.status_standardize' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom">
              <nz-tag *ngIf="element.statusStandardized" [nzColor]="getStatusTagColor(element.statusStandardized)" style="margin-right: 0px;">
                {{ getStatusLabel(element.statusStandardized) }}
              </nz-tag>
            </mat-cell>
          </ng-container>
    
          <!-- Ghi chú / hành động -->
          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef class="mat-header-cell-center" style="max-width: 100px;">
              {{ 'labor_contract_standardize.execute.table_headers.note' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-header-cell-center" style="max-width: 100px;">
              <button mat-icon-button
                      [matTooltip]="'labor_contract_standardize.execute.btn_view' | translate"
                      (click)="onView(element)">
                <mat-icon>visibility</mat-icon>
              </button>
    
              <button mat-icon-button
                      [matMenuTriggerFor]="rowMenu"
                      (click)="$event.stopPropagation()">
                <mat-icon>more_vert</mat-icon>
              </button>
    
              <mat-menu #rowMenu="matMenu">
                <button mat-menu-item (click)="openNoteDialog(element)">
                  <mat-icon>check_circle_outline</mat-icon>
                  <span>{{ 'labor_contract_standardize.btn_view_more' | translate }}</span>
                </button>
              </mat-menu>
            </mat-cell>
          </ng-container>
    
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
    
      </div>
    
      <!-- Pagination -->
      <app-pagination [(paginate)]="paginate"
                      (pageChange)="onFilterData($event.page, $event.pageSize)">
      </app-pagination>
    </mat-expansion-panel>
  </mat-accordion>
  



</div>

<div class="standardize-process" *ngIf="showStandardizeProcess">
  <div class="steps-title standardize-steps-title" id="step_title">
    <nz-steps [nzCurrent]="currentStandardizeStep" class="standardize-stepper">
      <nz-step [nzTitle]="standardizeTitleStep1">
        <ng-template #standardizeTitleStep1>
          {{ 'labor_contract_standardize.steps.upload_info' | translate }}
        </ng-template>
      </nz-step>
      <nz-step [nzTitle]="standardizeTitleStep2">
        <ng-template #standardizeTitleStep2>
          {{ 'labor_contract_standardize.steps.supplement_conditions' | translate }}
        </ng-template>
      </nz-step>
    </nz-steps>
  </div>

  <div class="supplement-card" *ngIf="currentStandardizeStep === 0">
    <div class="supplement-content">
      <h3 class="supplement-title">{{ 'labor_contract_standardize.supplement.title' | translate }}</h3>

      <button type="button"
              class="download-template-link"
              [disabled]="isDownloadingSupplementTemplate"
              (click)="downloadSupplementTemplate()">
        {{ 'labor_contract_standardize.supplement.download_template' | translate }}
      </button>

      <div class="supplement-upload-zone"
           [class.dragging]="isSupplementFileDragging"
           (dragover)="onSupplementFileDragOver($event)"
           (dragleave)="onSupplementFileDragLeave($event)"
           (drop)="onSupplementFileDrop($event)">
        <input #supplementFileInput
               type="file"
               class="d-none"
               accept=".xlsx"
               (change)="onSupplementFileSelected($event)">

        <ng-container *ngIf="!selectedSupplementFile">
          <mat-icon class="upload-cloud-icon">cloud_upload</mat-icon>
          <div class="upload-title">{{ 'labor_contract_standardize.supplement.upload_title' | translate }}</div>
          <div class="upload-description">{{ 'labor_contract_standardize.supplement.upload_description' | translate }}</div>
          <button type="button"
                  mat-stroked-button
                  color="primary"
                  class="choose-file-button"
                  (click)="openSupplementFilePicker(supplementFileInput)">
            <mat-icon>cloud_upload</mat-icon>
            {{ 'labor_contract_standardize.supplement.choose_file' | translate }}
          </button>
        </ng-container>

        <ng-container *ngIf="selectedSupplementFile">
          <mat-icon class="upload-cloud-icon">cloud_upload</mat-icon>
          <div class="upload-title">{{ 'labor_contract_standardize.supplement.upload_title' | translate }}</div>
          <div class="upload-description">{{ 'labor_contract_standardize.supplement.upload_description' | translate }}</div>
          <span class="selected-file-link" [matTooltip]="selectedSupplementFile.name">
            {{ selectedSupplementFile.name }}
          </span>
          <button type="button"
                  mat-stroked-button
                  color="primary"
                  class="choose-file-button"
                  (click)="openSupplementFilePicker(supplementFileInput)">
            <mat-icon>cloud_upload</mat-icon>
            {{ 'labor_contract_standardize.supplement.choose_other_file' | translate }}
          </button>
        </ng-container>
      </div>

      <div class="supplement-notes">
        <div>{{ 'labor_contract_standardize.supplement.notes_title' | translate }}</div>
        <div>{{ 'labor_contract_standardize.supplement.note_1' | translate }}</div>
        <div>{{ 'labor_contract_standardize.supplement.note_2' | translate }}</div>
      </div>
    </div>

    <div class="supplement-actions">
      <button type="button"
              mat-stroked-button
              color="primary"
              class="btn mr-3"
              style="font-size: 14px !important; font-weight: 500;"
              (click)="cancelStandardizeProcess()">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{ 'form.cancel' | translate }}
      </button>
      <button type="button"
              mat-raised-button
              color="primary"
              class="btn submit-button"
              style="font-size: 14px !important; font-weight: 500;"
              [disabled]="!selectedSupplementFile || isSubmittingSupplementFile"
              (click)="submitSupplementFile()">
        <mat-icon class="mr-0">arrow_forward</mat-icon>
        {{ 'labor_contract_standardize.supplement.btn_submit' | translate }}
      </button>
    </div>
  </div>

  <ng-container *ngIf="currentStandardizeStep === 1">
    <div class="standardize-notice" role="status">
      <mat-icon>info</mat-icon>
      <span>
        {{ 'labor_contract_standardize.supplement.notice' | translate }}<br>
        {{ 'labor_contract_standardize.supplement.notice_2' | translate }}
      </span>
    </div>

    <section class="condition-contract-list">
      <button type="button" class="condition-list-toggle" (click)="toggleResultSummary()">
        <span class="condition-list-title">
          {{ 'labor_contract_standardize.result.list_title' | translate }}
          <strong>({{ standardizeProcessPaginate.totalRow }})</strong>
        </span>
        <mat-icon>{{ isResultSummaryExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>

      <div class="condition-list-content" *ngIf="isResultSummaryExpanded">
        <div class="condition-result-header">
          <div class="condition-result-info">
            <div *ngIf="isSupplementProcessDone">
              {{ 'labor_contract_standardize.result.supplement_result' | translate }}
              <button type="button"
                      class="condition-result-link"
                      [disabled]="isDownloadingSupplementResult"
                      (click)="downloadSupplementResult()">
                {{ supplementResultFileName }}
              </button>
            </div>
            <div>{{ 'labor_contract_standardize.result.import_lot_code' | translate }} <strong>{{ importLotCode || '-' }}</strong></div>
          </div>

          <div class="result-summary">
            <span class="summary-pill summary-total" *ngIf="isSupplementProcessDone">
              {{ 'labor_contract_standardize.result.total_records' | translate }} {{ supplementResult.totalRecords }}
            </span>
            <span class="summary-pill summary-valid" *ngIf="isSupplementProcessDone">
              {{ 'labor_contract_standardize.result.valid_records' | translate }} {{ supplementResult.validRecords }}
            </span>
            <span class="summary-pill summary-invalid" *ngIf="isSupplementProcessDone">
              {{ 'labor_contract_standardize.result.invalid_records' | translate }} {{ supplementResult.invalidRecords }}
            </span>
          </div>
        </div>

        <div class="result-progress">
          <span class="result-progress-value"
                [style.width.%]="supplementResult.progress">
          </span>
        </div>
        <div class="result-progress-label">
          {{ 'labor_contract_standardize.result.processed_progress' | translate: { percent: supplementResult.progress } }}
        </div>

        <div class="condition-table-section">
          <div class="condition-table-wrapper">
        <mat-table [dataSource]="standardizeProcessDataSource.data"
                   class="w-100 mat-table-col-extra-sm standardize-condition-table">
          <ng-container matColumnDef="stt">
            <mat-header-cell *matHeaderCellDef class="condition-stt-column">{{ 'labor_contract_standardize.execute.table_headers.no' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let element" class="condition-stt-column">{{ element.stt }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="codeName">
            <mat-header-cell *matHeaderCellDef>{{ 'labor_contract_standardize.result.table_headers.code_name' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let element" [matTooltip]="element.codeName">
              <span class="condition-cell-text">{{ element.codeName }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="contractType">
            <mat-header-cell *matHeaderCellDef>{{ 'labor_contract_standardize.result.table_headers.contract_type' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let element" [matTooltip]="element.contractType">
              <span class="condition-cell-text">{{ element.contractType }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="parties">
            <mat-header-cell *matHeaderCellDef>{{ 'labor_contract_standardize.result.table_headers.parties' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let element" [matTooltip]="element.parties">
              <span class="condition-cell-text">{{ element.parties }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="statusCksNsdld">
            <mat-header-cell *matHeaderCellDef class="condition-status-column">{{ 'labor_contract_standardize.result.table_headers.status_cks_nsdld' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let element" class="condition-status-column">
              <nz-tag *ngIf="element.statusCksNsdld" [nzColor]="getStatusTagColor(element.statusCksNsdld)" style="margin-right: 0px;">
                {{ getStatusLabel(element.statusCksNsdld) }}
              </nz-tag>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="statusCksNld">
            <mat-header-cell *matHeaderCellDef class="condition-status-column">{{ 'labor_contract_standardize.result.table_headers.status_cks_nld' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let element" class="condition-status-column">
              <nz-tag *ngIf="element.statusCksNld" [nzColor]="getStatusTagColor(element.statusCksNld)" style="margin-right: 0px;">
                {{ getStatusLabel(element.statusCksNld) }}
              </nz-tag>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="statusSupplementHDLD">
            <mat-header-cell *matHeaderCellDef class="condition-status-column">{{ 'labor_contract_standardize.result.table_headers.status_supplement_hdld' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let element" class="condition-status-column">
              <nz-tag *ngIf="element.statusSupplementHDLD" [nzColor]="getStatusTagColor(element.statusSupplementHDLD)" style="margin-right: 0px;">
                {{ getSupplementProcessStatusLabel(element.statusSupplementHDLD) }}
              </nz-tag>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="statusStandardized">
            <mat-header-cell *matHeaderCellDef class="condition-status-column">{{ 'labor_contract_standardize.result.table_headers.status_standardize' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let element" class="condition-status-column">
              <nz-tag *ngIf="element.statusStandardized" [nzColor]="getStatusTagColor(element.statusStandardized)" style="margin-right: 0px;">
                {{ getStandardizeProcessStatusLabel(element.statusStandardized) }}
              </nz-tag>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="note">
            <mat-header-cell *matHeaderCellDef class="condition-note-column">{{ 'labor_contract_standardize.result.table_headers.note' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let element" class="condition-note-column">
              <button type="button"
                      class="condition-detail-link"
                      *ngIf="hasReviewError(element); else noReviewError"
                      (click)="openNoteDialog(element)">
                {{ 'labor_contract_standardize.result.view_detail' | translate }}
              </button>
              <ng-template #noReviewError>-</ng-template>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="standardizeProcessDisplayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: standardizeProcessDisplayedColumns;"></mat-row>
        </mat-table>

        </div>

          <app-pagination [(paginate)]="standardizeProcessPaginate"
                          (pageChange)="onStandardizeProcessPageChange($event.page, $event.pageSize)">
          </app-pagination>
        </div>
      </div>
    </section>

    <div class="condition-close-actions">
      <button type="button"
              mat-stroked-button
              color="primary"
              (click)="returnToStandardizeMenu()">
        <mat-icon>cancel</mat-icon>
        {{ 'button.close' | translate }}
      </button>
    </div>
  </ng-container>
</div>

<ng-template #reviewErrorDialog>
  <h2 mat-dialog-title class="review-error-dialog-title">
    {{ 'labor_contract_standardize.review_error_dialog.title' | translate }}
    <button type="button" mat-icon-button mat-dialog-close [attr.aria-label]="'button.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="review-error-dialog-content">
    <div class="review-error-contract-name" *ngIf="selectedReviewErrorContract">
      {{ selectedReviewErrorContract.codeName }}
    </div>

    <div class="review-error-item"
         *ngFor="let detail of selectedReviewErrorDetails; let index = index">
      <div class="review-error-condition">{{ index + 1 }}. {{ detail.condition }}</div>
      <div class="review-error-message">{{ detail.message }}</div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button type="button" mat-stroked-button color="primary" mat-dialog-close>
      {{ 'button.close' | translate }}
    </button>
  </mat-dialog-actions>
</ng-template>
